import React from 'react';

import { ImageInput } from 'src/app/components/lib/image-input';

import { useDiscountWizardStateContext } from '../../state';
import { OnlineDetailsStepActions } from '../../state/online-details';
import { useMenuCardImageUpload } from '../../use-menu-card-image-upload';

export function ImageUpload() {
  const {
    onlineDetailsStepDispatch,
    onlineDetailsStepState: { imageUrl },
  } = useDiscountWizardStateContext();

  const addMenuDisplayImage = useMenuCardImageUpload({
    onUploadSuccess: (imageUrl) =>
      onlineDetailsStepDispatch({ type: OnlineDetailsStepActions.SET_IMAGE_URL, payload: imageUrl }),
  });

  return (
    <ImageInput
      fullWidth
      images={imageUrl ? [imageUrl] : []}
      label='Image:'
      labelPlacement='top'
      limit={1}
      maintainAspectRatio
      promptButtonLabel='Choose image'
      promptMessage='Upload an image for your special. Uploaded images should be 765 x 330 and in JPEG or PNG format.'
      onImageDelete={() =>
        onlineDetailsStepDispatch({ type: OnlineDetailsStepActions.SET_IMAGE_URL, payload: undefined })
      }
      onImageSelect={({ target }: React.ChangeEvent<HTMLInputElement>) => addMenuDisplayImage(target)}
    />
  );
}
